import { render, staticRenderFns } from "./aboutIntro.vue?vue&type=template&id=0f88184d&scoped=true&"
import script from "./aboutIntro.vue?vue&type=script&lang=js&"
export * from "./aboutIntro.vue?vue&type=script&lang=js&"
import style0 from "./aboutIntro.vue?vue&type=style&index=0&id=0f88184d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88184d",
  null
  
)

export default component.exports